module.exports = __webpack_public_path__ + "static/media/Rubeus Hagrid 1.8834a462.jpg";